import { InjectionToken } from '@angular/core';
import { ApiConfigurationInterface } from '../interfaces';

export const API_CONFIGURATION = new InjectionToken<ApiConfigurationInterface>('ApiConfiguration');
